module.exports = __webpack_public_path__ + "static/media/main_rwd.03ce52a0.png";